import styled from '@emotion/styled';
import { useContext } from 'react';
import { TranslationContext } from '../../handlers/TranslationsHandler';

const TipContent = styled.div`
  width: 300px;
  height: fit-content;
`;

const TipHeader = styled.h1`
  font-style: normal;
  font-weight: 400;
  font-size: 20px;
  letter-spacing: -0.015em;
  text-transform: uppercase;
  color: #3b3b3b;
`;

const TooltipText = styled.p`
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 19px;
  display: flex;
  align-items: center;
  letter-spacing: -0.015em;
  padding: 15px;
  display: inline-block;
`;

const Link = styled.a`
  color: rgba(144, 163, 0, 1);
  text-decoration: underline;
`;

const LeftArrow = styled.div`
  position: relative;
  transform: rotate(30deg);
  left: -10px;
  top: 30px;
  width: 0;
  height: 0;
  border-left: 10px solid transparent;
  border-right: 10px solid transparent;
  border-bottom: 17.32px solid #fff;
`;

const HeaderContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 15px 15px 15px;
  border-bottom: 1px solid #e0e0e0;
`;

export const TooltipBody = () => {
  const { translate } = useContext(TranslationContext);

  return (
    <TipContent>
      <LeftArrow />
      <HeaderContainer>
        <TipHeader>{translate('premiumTile')}</TipHeader>
      </HeaderContainer>
      <TooltipText>
        {translate('upgradeLink')} (
        <Link
          href="https://agora.umi.city/#/solutions_usi_ui-cockpit-starter"
          target="_blank"
        >
          Link
        </Link>
        ).
      </TooltipText>
    </TipContent>
  );
};
